import { useMutation } from '@tanstack/react-query'
import { Link, useSearch } from '@tanstack/react-router'
import { useState } from 'react'
import { AuthShell } from '@/components/auth-shell'
import { BtnPrimary, Field, TextInput } from '@/components/field'
import { apiMutate, ApiError } from '@/lib/api'

export function MotDePasseReinitPage() {
  const search = useSearch({ strict: false }) as { token?: string }
  const token = typeof search.token === 'string' ? search.token : ''
  const [password, setPassword] = useState('')
  const [confirm, setConfirm] = useState('')
  const [error, setError] = useState<string | null>(null)
  const [done, setDone] = useState(false)

  const reset = useMutation({
    mutationFn: () =>
      apiMutate('/staff/auth/password/reset', 'POST', {
        token,
        newPassword: password,
      }),
    onSuccess: () => {
      setError(null)
      setDone(true)
    },
    onError: (e: Error) => setError(e instanceof ApiError ? e.message : e.message),
  })

  return (
    <AuthShell
      title="Nouveau mot de passe"
      subtitle="Choisissez un mot de passe d’au moins 10 caractères."
      footer={
        <Link to="/connexion" className="text-rouge underline">
          Retour à la connexion
        </Link>
      }
    >
      {!token ? (
        <p className="text-sm text-rouge">Lien invalide ou incomplet.</p>
      ) : done ? (
        <div className="space-y-3 text-sm">
          <p>Mot de passe mis à jour. Vous pouvez vous connecter.</p>
          <Link to="/connexion" className="text-rouge underline">
            Se connecter
          </Link>
        </div>
      ) : (
        <form
          className="flex flex-col gap-3"
          onSubmit={(e) => {
            e.preventDefault()
            if (password !== confirm) {
              setError('Les mots de passe ne correspondent pas.')
              return
            }
            reset.mutate()
          }}
        >
          {error ? (
            <p className="rounded-lg bg-rouge/10 px-3 py-2 text-sm text-rouge" role="alert">
              {error}
            </p>
          ) : null}
          <Field label="Nouveau mot de passe">
            <TextInput
              type="password"
              autoComplete="new-password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              minLength={10}
              required
            />
          </Field>
          <Field label="Confirmer">
            <TextInput
              type="password"
              autoComplete="new-password"
              value={confirm}
              onChange={(e) => setConfirm(e.target.value)}
              minLength={10}
              required
            />
          </Field>
          <BtnPrimary type="submit" disabled={reset.isPending}>
            {reset.isPending ? 'Enregistrement…' : 'Enregistrer'}
          </BtnPrimary>
        </form>
      )}
    </AuthShell>
  )
}
